// @core/api/endpoints/subscription/update_add_on.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AddOnResponse,
  UpdateAddOnRequest,
} from '../../../types/subscription';

const BASE_PATH = '/subscription';

/**
 * Update addon
 * Updates addon configuration. Price changes only affect new purchases.
 */
export async function UpdateAddOn(
  addon_id: string,
  data: UpdateAddOnRequest,
  options?: RequestOptions
): Promise<AddOnResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/addons/:addon_id`;
  requestPath = requestPath.replace(':addon_id', encodeURIComponent(addon_id));
  const requestOptions = options;
  return client.put<AddOnResponse>(requestPath, data, requestOptions);
}
